module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clientele"
  }, [_c('banner', {
    attrs: {
      "url": "clientele",
      "clazz": "clientele-banner"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clientele-con"
  }, [_c('div', {
    staticClass: "box-top clearfix"
  }, [_c('div', {
    staticClass: "top-tab"
  }, [_c('span', {
    class: _vm.topLightStyle,
    on: {
      "click": _vm.districtClick
    }
  }, [_vm._v("标杆客户")]), _vm._v(" "), _c('span', {
    class: _vm.lightStyle,
    on: {
      "click": _vm.industryClick
    }
  }, [_vm._v("行业选择 "), _c('img', {
    attrs: {
      "src": require("../../assets/img/clientele/up.svg"),
      "alt": "行业选择"
    }
  })])]), _vm._v(" "), _c('el-button', {
    staticClass: "top-button",
    on: {
      "click": function($event) {
        return _vm.goRegister('anliliebiao-banner-xiangqing')
      }
    }
  }, [_vm._v("获取案例详情")])], 1), _vm._v(" "), (_vm.industryShow) ? _c('div', {
    staticClass: "checkDiv",
    on: {
      "mouseleave": _vm.industryClick
    }
  }, _vm._l((_vm.industryCon), function(item) {
    return _c('span', {
      key: item.id,
      staticClass: "cp",
      class: {
        IsclickClass: _vm.industry === item.id
      },
      on: {
        "click": function($event) {
          return _vm.Isclick(item, 'industry')
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clientele-box"
  }, [_c('div', {
    staticClass: "box-bottom"
  }, [(_vm.IsHaveData) ? _c('div', {
    staticClass: "content-dynamic clearfix",
    attrs: {
      "id": "box-bottom"
    }
  }, [_vm._l((_vm.dataList), function(item) {
    return _c('a', {
      key: item.id,
      staticClass: "dynamic-div cp db",
      attrs: {
        "href": _vm.getCaseDetile(item),
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "dynamic-div-img",
      style: ({
        'backgroundImage': 'url(' + _vm.$global.globalPath + item.keh_img + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "dynamic-div-title"
    }, [_c('div', {
      staticClass: "dynamic-div-logo"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.$global.globalPath + item.keh_logo),
        expression: "$global.globalPath + item.keh_logo"
      }],
      attrs: {
        "alt": "甄云客户案例"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "div-title-bottom"
    }, [_c('p', [_vm._v(_vm._s(item.keh_describe))])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IsMore),
      expression: "IsMore"
    }],
    staticClass: "dynamic-more"
  }, [_c('span', {
    attrs: {
      "loading": _vm.IsloadMore
    },
    on: {
      "click": _vm.upCallback
    }
  }, [_vm._v("加载更多"), _c('img', {
    attrs: {
      "src": require("../../assets/img/clientele/loadMore.png"),
      "alt": "加载更多"
    }
  })])])], 2) : _vm._e(), _vm._v(" "), (!_vm.IsHaveData) ? _c('div', {
    staticClass: "content-dynamic-box"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "src": require("../../assets/img/clientele/clienteleImg.png"),
      "alt": "甄云客户案例"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-box-top"
  }, [_c('span', {
    staticClass: "box-top-one"
  }, [_vm._v("sorry，案例暂未上传， ")]), _vm._v(" "), _c('span', {
    staticClass: "box-top-two cp",
    on: {
      "click": _vm.gitConData
    }
  }, [_vm._v("返回案例总页面")])]), _vm._v(" "), _vm._m(0)]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dynamic-box-bottom"
  }, [_c('span', {
    staticClass: "box-bottom-one"
  }, [_vm._v("您也可拨打")]), _vm._v(" "), _c('span', {
    staticClass: "box-bottom-two"
  }, [_vm._v("400-116-0808")]), _vm._v(" "), _c('span', {
    staticClass: "box-bottom-three"
  }, [_vm._v("获取该行业相关案例")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55014341"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clientele/clientele.vue
// module id = 651
// module chunks = 12